import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { NzCollapseModule } from 'ng-zorro-antd/collapse';
import { TranslatePipe } from '@ngx-translate/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NzFormModule } from 'ng-zorro-antd/form';
import { BulkEditQualificationSelectionHasMixedValues } from '../../../../types';
import { NzInputModule } from 'ng-zorro-antd/input';

@Component({
  selector: 'wilson-bulk-qualifications-notes-section',
  imports: [
    FormsModule,
    NzCollapseModule,
    NzFormModule,
    ReactiveFormsModule,
    TranslatePipe,
    NzInputModule,
  ],
  templateUrl: './bulk-qualifications-notes-section.component.html',
  styleUrl: './bulk-qualifications-notes-section.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BulkQualificationsNotesSectionComponent {
  @Input() active: boolean | null = true;
  @Input() disabled: boolean | null = false;

  @Input() notesFormControl: FormControl<string | null> = new FormControl<
    string | null
  >(null);

  @Input() hasMixedValues: Pick<
    BulkEditQualificationSelectionHasMixedValues,
    'notes'
  > = {
    notes: false,
  };
}
